erpnext.ProductGrid = class {
	/* Options:
		- items: Items
		- settings: E Commerce Settings
		- products_section: Products Wrapper
		- preference: If preference is not grid view, render but hide
	*/
	constructor(options) {
		Object.assign(this, options);

		if (this.preference !== "Grid View") {
			this.products_section.addClass("hidden");
		}

		this.theme = this.theme || "Theme 1";
		this.products_section.empty();
		this.make(this.onReady);
	}

	lazy_load_items_prices(settings, item_codes_filter) {
		let me = this;
		var item_codes = this.cached_items
			? this.cached_items.map(p => p.item_code)
			: (this.items || []).map(p => p.item_code);
		if (item_codes_filter && item_codes_filter.length) {
			item_codes = item_codes.filter(c => item_codes_filter.indexOf(c) !== -1);
		}
		if (!item_codes.length) return;
		frappe.call({
			method: "erpnext.e_commerce.api.get_website_items_prices",
			args: {
				item_codes: JSON.stringify(item_codes)
			},
			callback: function (data) {
				const message = data.message || [];
				const returnedCodes = new Set(message.map(p => p.item_code));

				// First, handle all items that have a price returned from the server
				for (var item_price of message) {
					var cachedItem = me.cached_items.find(x => x.item_code == item_price.item_code);
					if (!cachedItem) continue;
					cachedItem.price = item_price.price;

					var priceHtml = me.get_price_html(cachedItem, settings, false);
					var $priceContainer = $(`.product-price[data-item-code="${cachedItem.item_code}"]`);
					$priceContainer.html(priceHtml);

					// Remove existing add-to-cart buttons in this card to avoid duplicates
					var $card = $priceContainer.closest(".item-card");
					$card.find(".btn-add-to-cart-list, .go-to-cart-grid").remove();

					var primaryButtonHtml = me.get_primary_button(cachedItem, settings, false);
					if (me.theme === "Theme 2") {
						$priceContainer.closest(".wish-price-row").after(primaryButtonHtml);
					} else {
						$priceContainer.append(primaryButtonHtml);
					}
				}

				// Then, for items that were requested but did NOT get a price,
				// remove the loader and show the "contact for price" state.
				item_codes.forEach(function (code) {
					if (returnedCodes.has(code)) return;

					var cachedItem = me.cached_items.find(x => x.item_code == code);
					if (!cachedItem) return;

					// Explicitly mark as having no buyable price
					cachedItem.price = null;

					var $priceContainer = $(`.product-price[data-item-code="${cachedItem.item_code}"]`);
					var priceHtml = me.get_price_html(cachedItem, settings, false);
					$priceContainer.html(priceHtml);

					var $card = $priceContainer.closest(".item-card");
					$card.find(".btn-add-to-cart-list, .go-to-cart-grid").remove();

					var primaryButtonHtml = me.get_primary_button(cachedItem, settings, false);
					if (me.theme === "Theme 2") {
						$priceContainer.closest(".wish-price-row").after(primaryButtonHtml);
					} else {
						$priceContainer.append(primaryButtonHtml);
					}
				});
			}
		});
	}

	appendItems(items) {
		if (!items || items.length === 0) return;
		const me = this;
		const place_holder = me.place_holder || "";
		const frag = document.createDocumentFragment();
		for (const item of items) {
			let title = item.web_item_name || item.item_name || item.item_code || "";
			title = title.length > 90 ? title.substr(0, 90) + "..." : title;
			const el = me.build_item_card_element(item, title, place_holder, me.settings);
			if (el) frag.appendChild(el);
		}
		const $sentinel = this.products_section.find(".product-grid-progressive-sentinel");
		if ($sentinel.length) {
			// Append new cards before the sentinel so they follow the existing batch in DOM
			// order. The sentinel has no flex footprint (width:0;height:0) so it does not
			// displace cards visually under flex-row-reverse.
			$sentinel.before(html);
		} else {
			this.products_section.append(html);
		}
		this.cached_items = (this.cached_items || []).concat(items);
		// Only fetch/update prices for the newly appended items to avoid duplicate buttons
		var new_codes = items.map(p => p.item_code);
		this.lazy_load_items_prices(this.settings, new_codes);
	}

	make(onReady) {
		let me = this;
		const render = (place_holder_val) => {
			me.place_holder = place_holder_val;
			me.cached_items = this.items;
			const frag = document.createDocumentFragment();
			for (const item of this.items) {
				let title = item.web_item_name || item.item_name || item.item_code || "";
				title = title.length > 90 ? title.substr(0, 90) + "..." : title;
				const el = me.build_item_card_element(item, title, place_holder_val, me.settings);
				if (el) frag.appendChild(el);
			}
			const wrapEl = this.products_section.get(0);
			if (wrapEl) wrapEl.appendChild(frag);
			me.lazy_load_items_prices(me.settings);
			$(".loader-box").remove();
		};
		const wph =
			typeof window !== "undefined" &&
			window.all_products_place_holder &&
			String(window.all_products_place_holder).length;
		if (wph) {
			render(window.all_products_place_holder);
			return;
		}
		frappe.call({
			method: "erpnext.templates.pages.product_search.get_place_holder",
			args: {},
			async: false,
			callback: (data) => {
				me.place_holder = data.message.place_holder;
				me.cached_items = this.items;
				for (const item of this.items) {
					let title = item.web_item_name || item.item_name || item.item_code || "";
					title = title.length > 90 ? title.substr(0, 90) + "..." : title;

					html += `<div class="item-card-width item-card p-1" style="height: fit-content !important;"><div class="card text-left">`;
					html += me.get_image_html(item, title, data.message.place_holder);
					html += me.get_card_body_html(item, title, me.settings);
					html += `</div></div>`;
				}

				let $product_wrapper = this.products_section;
				$product_wrapper.append(html);
				me.lazy_load_items_prices(me.settings);
				$(".loader-box").remove();

				if (typeof onReady === "function") onReady();

				// Resize Card Photos
				// setTimeout(() => {
				// 	const cards = document.querySelectorAll(".item-card");
				// 	cards.forEach(card => {
				// 		const imgContainer = card.querySelector(".card-img-container");
				// 		const body = card.querySelector(".card-body");
				// 		if (imgContainer && body) {
				// 			const imgHeight = imgContainer.offsetHeight;
				// 			const bodyHeight = body.offsetHeight;
				// 			const maxHeight = bodyHeight * 1.5;

				// 			if (imgHeight > maxHeight) {
				// 				imgContainer.style.maxHeight = `${maxHeight}px`;
				// 				imgContainer.style.overflow = "hidden";
				// 			}
				// 		}
				// 	});
				// }, 100);

			}
		});

		// this.items.forEach((item) => {
		// 	let title = item.web_item_name || item.item_name || item.item_code || "";
		// 	title = title.length > 90 ? title.substr(0, 90) + "..." : title;

		// 	html += `<div class="col-sm-6 col-12 col-md-4 col-lg-3 item-card" style="height: fit-content !important;"><div class="card text-left">`;
		// 	html += me.get_image_html(item, title);
		// 	html += me.get_card_body_html(item, title, me.settings);
		// 	html += `</div></div>`;
		// });

		// let $product_wrapper = this.products_section;
		// $product_wrapper.append(html);
	}

	get_image_html(item, title, place_holder) {
		let image = item.website_image;

		if (image) {
			return `
				<div class="card-img-container">
					<a href="/${item.route || "#"}" style="text-decoration: none;">
						<img class="card-img lazyload" src="${image}" alt="${title}" 
							onerror="this.onerror=null; this.src='${place_holder}'; this.classList.add('placeholder-img');">
					</a>
					${this.get_variants(item)}
				</div>
			`;
		} else {
			return `
				<div class="card-img-container">
						<a class="card-placeholder-link" href="/${item.route || '#'}" style="text-decoration: none;">
							<img class="card-img placeholder-img lazyload" src="${place_holder}" alt="${title}">
						</a>
						${this.get_variants(item)}
				</div>
			`;
		}
	}

	get_card_body_html(item, title, settings) {
		// Theme-based card layouts
		if (this.theme === "Theme 2") {
			return this.get_card_body_html_theme_2(item, title, settings);
		} else if (this.theme === "Theme 3") {
			return this.get_card_body_html_theme_3(item, title, settings);
		} else {
			// Theme 1 (default)
			return this.get_card_body_html_theme_1(item, title, settings);
		}
	}

	get_card_body_html_theme_1(item, title, settings) {		
		let body_html = `
			<div class="card-body text-left card-body-flex" style="width:100%">
				<div style="margin-top: 1rem; display: flex;flex-direction: column">
		`;
		body_html += `<div class="d-flex delivery-detail-box">`;
		body_html += `<div class="col-4 p-0">${this.get_stock_availability(item, settings)}</div>`;
		body_html += `<div class="col-4 p-0">${this.get_gift(item)}</div>`;
		if(item.engrave){
			body_html += `<div class="col-4 p-0">${this.get_engrave(item)}</div>`;
		}
		else{

		}
		body_html += `</div>`


		body_html += this.get_title(item, title);
		// get floating elements
		if (!item.has_variants) {
			if (settings.enable_wishlist) {
				body_html += this.get_wishlist_icon(item);
			}
			if (settings.enabled) {
				body_html += this.get_cart_indicator(item);
			}
		}
		
		body_html += `</div>`;
		body_html += this.get_original_name(item);
		body_html += `<h4 class="product-category">${item.item_group || ""}</h4>`;

		body_html += this.get_price_html(item, settings);
		

		body_html += this.get_primary_button(item, settings);
		body_html += `</div>`; // close div on line 49

		return body_html;
	}

	get_card_body_html_theme_2(item, title, settings) {
		// Alternative layout for Theme 2
		let body_html = `
			<div class="card-body text-left card-body-flex" style="width:100%;gap: 10px;">
				<div style="margin-top: 1rem; display: flex;flex-direction: column">
		`;

		body_html += this.get_title(item, title);
		if (!item.has_variants) {
			if (settings.enabled) {
				body_html += this.get_cart_indicator(item);
			}
		}
		
		body_html += `</div>`;
		body_html += this.get_original_name(item);
		body_html += `<h4 class="product-brand text-right">${item.brand_name || ""}</h4>`;
		body_html += `<h4 class="product-author text-right">${item.author_name || ""}</h4>`;
	
		
		
		body_html += `<div style="display: flex; width: 100%;border-bottom: 1px solid #e0e0e0;"></div>`;
		
		// Wishlist and Price Row
		body_html += `<div class="wish-price-row" style="display: flex; justify-content: space-between; align-items: center; direction: rtl;">`;
		if (!item.has_variants && settings.enable_wishlist && (item.in_stock || item.allow_seller)) {
			body_html += this.get_wishlist_icon(item);
		}
		body_html += this.get_price_html(item, settings);
		body_html += `</div>`;
		
		body_html += this.get_primary_button(item, settings);
		body_html += `</div>`;

		return body_html;
	}

	get_card_body_html_theme_3(item, title, settings) {
		// Another alternative layout for Theme 3
		let body_html = `
			<div class="card-body text-left card-body-flex" style="width:100%">
				<div style="margin-top: 1rem; display: flex;flex-direction: column">
		`;
		body_html += `<div class="d-flex delivery-detail-box">`;
		body_html += `<div class="col-4 p-0">${this.get_stock_availability(item, settings)}</div>`;
		body_html += `<div class="col-4 p-0">${this.get_gift(item)}</div>`;
		if(item.engrave){
			body_html += `<div class="col-4 p-0">${this.get_engrave(item)}</div>`;
		}
		body_html += `</div>`

		body_html += this.get_title(item, title);
		if (!item.has_variants) {
			if (settings.enable_wishlist) {
				body_html += this.get_wishlist_icon(item);
			}
			if (settings.enabled) {
				body_html += this.get_cart_indicator(item);
			}
		}
		
		body_html += `</div>`;
		body_html += this.get_original_name(item);
		body_html += `<h4 class="product-category">${item.item_group || ""}</h4>`;
		body_html += this.get_price_html(item, settings);
		body_html += this.get_primary_button(item, settings);
		body_html += `</div>`;

		return body_html;
	}
	get_original_name(item){

		let original_name_html = `
		<div style="direction: rtl !important; font-size: 11px !important; font-weight:500">
			<a href="/${item.route || "#"}" ">
				<h3 class="product-original-name mt-2 mb-0 english-content" style="min-height: 20px;display: flex; align-items: center;line-height: 15px; font-weight: 400;">
					${item.original_name || ""}
				</h3>
			</a>
		</div>
		`;
		return original_name_html;

	}
	get_title(item, title) {
		let title_html = `
			<a href="/${item.route || "#"}">
				<h2 style="line-height: 22px; margin: 0 !important;font-weight: 500;" class="product-title">
					${title || ""}
				</h2>
			</a>
		`;
		return title_html;
	}

	get_wishlist_icon(item) {
		// Theme-based wishlist icons
		if (this.theme === "Theme 2") {
			return this.get_wishlist_icon_theme_2(item);
		} else if (this.theme === "Theme 3") {
			return this.get_wishlist_icon_theme_3(item);
		} else {
			return this.get_wishlist_icon_theme_1(item);
		}
	}

	get_wishlist_icon_theme_1(item) {
		let icon_class = item.wished ? "wished" : "not-wished";
		return `
			<div class="like-action ${item.wished ? "like-action-wished" : ""}"
				data-item-code="${item.item_code}">
				<i class="bi bi-heart-fill"></i>
			</div>
		`;
	}

	get_wishlist_icon_theme_2(item) {
		let icon_class = item.wished ? "wished" : "not-wished";
		return `
			<div class="like-action ${item.wished ? "like-action-wished" : ""}"
				data-item-code="${item.item_code}">
				<i class="bi bi-heart d-flex" style="height: 100%; WIDTH: 100%; justify-content: center; align-items: anchor-center; font-size: 14px;"></i>
			</div>
		`;
	}

	get_wishlist_icon_theme_3(item) {
		let icon_class = item.wished ? "wished" : "not-wished";
		return `
			<div class="like-action ${item.wished ? "like-action-wished" : ""}"
				data-item-code="${item.item_code}">
				<i class="bi bi-heart-fill"></i>
			</div>
		`;
	}

	get_cart_indicator(item) {
		return `
			<div class="cart-indicator ${item.in_cart ? "" : "hidden"}" data-item-code="${item.item_code}">
				1
			</div>
		`;
	}

	get_price_html(item, settings, put_loader = true) {
		// Theme-based price layouts
		if (this.theme === "Theme 2") {
			return this.get_price_html_theme_2(item, settings, put_loader);
		} else if (this.theme === "Theme 3") {
			return this.get_price_html_theme_3(item, settings, put_loader);
		} else {
			// Theme 1 (default)
			return this.get_price_html_theme_1(item, settings, put_loader);
		}
	}

	get_price_html_theme_1(item, settings, put_loader = true) {

		if(put_loader){
			return `
				<div class="product-price" data-item-code="${item.item_code}">
					<div class="spinner-border spinner-border-sm text-secondary" role="status"></div>
				</div>
			`
		}
		

		let price_html = ``

		if (!item.in_stock && !item.allow_seller){
			price_html += `
				<span class="out-of-stock my-2 d-flex align-items-center">
				<p class="col" style=" border-bottom: 1px solid var(--primary); display: flex; width: -webkit-fill-available;height: fit-content;"></p>
		 			<span class="px-2" style="color: #212121 !important;font-weight: 700 !important;font-size: 16px !important;">ناموجود</span>
		 		<p class="col" style=" border-bottom: 1px solid var(--primary); display: flex; width: -webkit-fill-available;height: fit-content;"></p>
				</span>
	
			`;
			return price_html;
		}

		const has_buyable_price = item.price && item.price.price_list_rate != null && item.price.price_list_rate > 0;
		if (item.show_price && settings.show_price && has_buyable_price && item.price.formatted_price) {
			price_html += `
				<div class="product-price my-2">
				
					${item.price.formatted_price.replace("تومان ", "") + " تومان"}
	
			`;
	
			if (item.price.formatted_mrp) {
				price_html += `
					<small class="striked-price">
						<s>${item.price.formatted_mrp ? item.price.formatted_mrp.replace("تومان ", "") + " تومان": "" }</s>
					</small>
					<small class="product-info-green">
						${item.price.discount_percent}%
					</small>
				`;
			}
			price_html += `</div>`;

		}
		else
		{
			// No buyable price: no text above red box, only the red box is shown
			price_html += `<div class="product-price my-2"></div>`;
		}

		return price_html;
	}

	get_price_html_theme_2(item, settings, put_loader = true) {

		if(put_loader){
			return `
				<div class="product-price" data-item-code="${item.item_code}" style="flex: 1;">
					<div class="spinner-border spinner-border-sm text-secondary" role="status"></div>
				</div>
			`
		}
		

		let price_html = ``

		if (!item.in_stock && !item.allow_seller){
			price_html += `
				<span class="out-of-stock d-flex align-items-center" style="flex: 1;">
		 			ناموجود
				</span>
	
			`;
			return price_html;
		}

		const has_buyable_price_theme2 = item.price && item.price.price_list_rate != null && item.price.price_list_rate > 0;
		if (item.show_price && settings.show_price && has_buyable_price_theme2 && item.price.formatted_price) {
		price_html += `
			<div class="product-price flex-column align-items-end d-flex" style="flex: 1;">
		`;

		if (item.price.formatted_mrp) {
			price_html += `
				<small class="striked-price">
					<s>${item.price.formatted_mrp ? item.price.formatted_mrp.replace("تومان ", "") + "": "" }</s>
				</small>
				<small class="product-info-green">
					${item.price.discount_percent}%
				</small>
			`;
		}
		
		price_html += `
			${item.price.formatted_price.replace("تومان ", "") + " تومان"}
		`;
		
		price_html += `</div>`;

	}
		else
		{
			// No buyable price: no text above red box
			price_html += `<div class="product-price my-2" style="flex: 1;"></div>`;
		}

		return price_html;
	}

	get_price_html_theme_3(item, settings, put_loader = true) {

		if(put_loader){
			return `
				<div class="product-price" data-item-code="${item.item_code}">
					<div class="spinner-border spinner-border-sm text-secondary" role="status"></div>
				</div>
			`
		}
		

		let price_html = ``

		if (!item.in_stock && !item.allow_seller){
			price_html += `
				<span class="out-of-stock my-2 d-flex align-items-center">
				<p class="col" style=" border-bottom: 1px solid var(--primary); display: flex; width: -webkit-fill-available;height: fit-content;"></p>
		 			<span class="px-2" style="color: #212121 !important;font-weight: 700 !important;font-size: 16px !important;">ناموجود</span>
		 		<p class="col" style=" border-bottom: 1px solid var(--primary); display: flex; width: -webkit-fill-available;height: fit-content;"></p>
				</span>
	
			`;
			return price_html;
		}

		const has_buyable_price_theme3 = item.price && item.price.price_list_rate != null && item.price.price_list_rate > 0;
		if (item.show_price && settings.show_price && has_buyable_price_theme3 && item.price.formatted_price) {
			price_html += `
				<div class="product-price my-2">
				
					${item.price.formatted_price.replace("تومان ", "") + " تومان"}
	
			`;
	
			if (item.price.formatted_mrp) {
				price_html += `
					<small class="striked-price">
						<s>${item.price.formatted_mrp ? item.price.formatted_mrp.replace("تومان ", "") + " تومان": "" }</s>
					</small>
					<small class="product-info-green">
						${item.price.discount_percent}%
					</small>
				`;
			}
			price_html += `</div>`;

		}
		else
		{
			// No buyable price: no text above red box
			price_html += `<div class="product-price my-2"></div>`;
		}

		return price_html;
	}

	get_engrave(itme){
		return`
			<div class="out-of-stock flex-column" style="text-align: center"><i class="bi bi-pen" style="color: #ABABAB;font-size: 18px !important;"></i><span style="color: #636161 !important;font-weight: 500 !important;font-size: 12px !important;line-height:18px;">حکاکی</span></div>
			`;

	}

	get_variants(item){

		var html = "";
		var new_html = "";

		if (item.variants){
			var routes = []
			item.variants.forEach(function(d) {
				if(d.all_colors){
					d.all_colors.forEach(function (data) {
						if(routes.indexOf(data.object_route) === -1){
							routes.push(data.object_route)
							html += `<a style="padding: 1px; display: flex; border-radius: 50%;width:fit-content !important; margin: 1px; border-width: 0px; border-style: solid; border-color:${data.color};"
										href="${data.object_route}"
										onmouseover="this.style.borderWidth='1px'; this.style.margin='0';"
										onmouseout="this.style.borderWidth='0px'; this.style.margin='1px';">
										<span style="background-color:${data.color};width: 8px; height: 8px; border-radius: 50%; padding: 4px; cursor: pointer;">
										</span>
									</a>`;
						}

					})
					
				}

			});
			
		}

		new_html += `<div class="d-flex justify-content-end flex-column">${html}</div>`
		
		let attrHtml = '';
		if (item.variants){

			item.variants.forEach(function(d){
	
				Object.keys(d).forEach(function (key) {
					if (key !== 'web_name' && key !== 'Colour' && key !== 'all_colors') {
						d[key].forEach(function (data) {
							attrHtml += `<a class="attr-pill-value" style="background-color: #cccccc83; width: fit-content; padding: 4px 8px; border-radius: 50px; color: gray; font-size: 10px;" href="${data.object_route}">
								<div>${data.value}</div>
							</a>`;
						});
			
						// Append each attribute's section to the main HTML string
					}
				});
			})
			new_html += `
					 <div class="d-flex flex-wrap" style="gap: 8px;">${attrHtml}</div>`;
		}
	

		
		var colorRow = `<div class="d-flex flex-column" style="gap:4px; justify-content: end;">
			${new_html}
		</div>`;


		var color_and_gift = ""

		if (item.gift){

			color_and_gift += `<div class="d-flex flex-column align-items-center justify-content-center var-color-card-box" style="position: absolute; right: 6px; top: 20px;">${colorRow}</div>`

		}else{
			color_and_gift += `<div class="d-none flex-column align-items-center justify-content-center" style="min-height:26px !important">${colorRow} </div>`
		}

		return color_and_gift;
	}

	get_gift(item){
		var new_html = "";

		var color_and_gift = ""

		if (item.gift){

			color_and_gift += `<div class="d-flex flex-column justify-content-between align-items-center"><i class="bi bi-gift-fill" style="color: #ABABAB;font-size: 18px !important;"></i><span style="color: #636161 !important;font-weight: 500 !important;font-size: 12px !important;line-height:18px;">کادو</span></div>`

		}else{
			color_and_gift += `<div class="d-flex justify-content-end align-items-center" style="min-height:26px !important"></div>`
		}

		return color_and_gift;
	}

	get_stock_availability(item, settings) {
		if (item.is_digital == 1){
			return `
					<span class="out-of-stock flex-column">
						${""}
					</span>
					`;
		}
		if (settings.show_stock_availability && !item.has_variants) {
			if (settings.show_stock_availability && item.in_stock && !item.allow_seller){
				return `
						<span class="out-of-stock flex-column">
						<i class="bi bi-truck" style="color: #ABABAB;font-size: 18px !important;"></i>
							<span style="color: #636161 !important;font-weight: 500 !important;font-size: 12px !important;line-height:18px;">ارسال فوری</span>
						</span>
						`;
			}
			if (item.on_backorder) {
				return`
					<span class="out-of-stock flex-column">
					<i class="bi bi-box-seam" style="color: #ABABAB;font-size: 18px !important;"></i>
						<span style="color: #636161 !important;font-weight: 500 !important;font-size: 12px !important;line-height:18px;">${__("Available on backorder")}</span>
					</span>
				`;
				// return `
				// 	<span class="out-of-stock mb-2 mt-1 flex-column" style="color: var(--primary-color)">
				// 		 ${__("Available on backorder")}
				// 	</span>
				// `;
			}

			 if (item.allow_seller) {
				if (settings.seller_description) {

					return `
						<span class="out-of-stock flex-column">
						<i class="bi bi-truck" style="color: #ABABAB;font-size: 18px !important;"></i>
							<span style="color: #636161 !important;font-weight: 500 !important;font-size: 12px !important;line-height:18px;">${__(settings.seller_description)}</span>
						</span>
					`;
				}

			} else{
				return``
			}
		}
		
	}

	get_primary_button(item, settings, put_loader = true) {

		if(put_loader){
			return ``;
		}

		if (item.has_variants) {
			return `
				<a href="/${item.route || '#'}">
					<div class="btn btn-sm btn-explore-variants w-100 mt-4">
						${'بررسی'}
					</div>
				</a>
			`;
		}
		// No price or zero price: show contact-for-price box instead of Add to cart (same size as green Add to cart, no hover/click)
		const has_buyable_price = item.price && item.price.price_list_rate != null && item.price.price_list_rate > 0;
		if (!has_buyable_price) {
			return `
				<div class="out-of-stock btn-contact-for-price w-100 mt-2 d-flex align-items-center justify-content-center rounded" data-item-code="${item.item_code}">
					برای اطلاع از قیمت تماس بگیرید
				</div>
			`;
		}
		if (settings.enabled && item.show_price && settings.show_price && (settings.allow_items_not_in_stock || item.in_stock || item.allow_seller)) {
			// return `
			// 	<div id="${item.name}" class="btn
			// 		btn-sm btn-primary btn-add-to-cart-list
			// 		w-100 mt-2 ${item.in_cart ? 'hidden' : ''}"
			// 		data-item-code="${item.item_code}">
			// 		<span class="mr-2">
			// 			<svg class="icon icon-md">
			// 				<use href="#icon-assets"></use>
			// 			</svg>
			// 		</span>
			// 		${settings.enable_checkout ? __('Add to Cart') : __('Add to Quote')}
			// 	</div>

			// 	<a href="/cart">
			// 		<div id="${item.name}" class="btn
			// 			btn-sm btn-primary btn-add-to-cart-list
			// 			w-100 mt-4 go-to-cart-grid
			// 			${item.in_cart ? '' : 'hidden'}"
			// 			data-item-code="${item.item_code}">
			// 			${settings.enable_checkout ? __('Go to Cart') : __('Go to Quote')}
			// 		</div>
			// 	</a>
			// `;
			return `
				<div id="${item.name}" class="btn
					btn-sm btn-primary btn-add-to-cart-list
					w-100 mt-2 ${item.in_cart ? 'hidden' : ''}"
					data-item-code="${item.item_code}">
					
					${settings.enable_checkout ? 'اضافه کردن به سبد خرید' : 'اضافه کردن به پیش سفارش'}
				</div>

			<a href="/cart" class="${item.in_cart ? '' : 'd-none'}">
				<div id="${item.name}" class="btn
					btn-sm btn-primary btn-add-to-cart-list
					w-100 mt-4 go-to-cart-grid
					${item.in_cart ? '' : 'hidden'}"
					data-item-code="${item.item_code}">
					${settings.enable_checkout ? 'رفتن به سبد خرید' : 'رفتن به پیش سفارش'}
				</div>
			</a>
			`;
		} else if (!item.show_price || !settings.show_price) {
			return `
				<div id="${item.name}" 
					class="btn btn-sm w-100 ${item.in_cart ? 'hidden' : ''}" 
					data-item-code="${item.item_code}" 
					style="pointer-events: none; opacity: 0.5; cursor: not-allowed; box-shadow: unset !important;">
					<span class="mr-2">
						<svg class="icon icon-md"></svg>
					</span>
				</div>

				`
		} else {
			// For Theme 2, don't show button when out of stock (out-of-stock message already shown in price section)
			if (this.theme === "Theme 2") {
				return ``;
			}
			// For other themes, show disabled button
			return `
				<button id="${item.name}" class="btn
					btn-sm btn-primary btn-add-to-cart-list
					w-100 mt-2 ${item.in_cart ? 'hidden' : ''}"
					data-item-code="${item.item_code}" disabled aria-disabled="true" style="border: unset !important;box-shadow: unset !important; outline: unset !important;">
					
					${settings.enable_checkout ? 'اضافه کردن به سبد خرید' : 'اضافه کردن به پیش سفارش'}
				</button>
			`;
		}
	}
};
